export const siteConfig = {
  experience: {
    ANNOUNCE: 'announce',
    REGISTRATION: 'registration',
    COUNTDOWN: 'countdown',
    CONFERENCE: 'conference',
    AFTER_CONFERENCE: 'afterConference',
  },
  conferencePreviewRedirects: {
    on: 'https://www.familysearch.org/en/labs/on/SFKY5GXKYPVHF0QZM04GV',
    off: 'https://www.familysearch.org/en/labs/off/SFKY5GXKYPVHF0QZM04GV',
  },
}
